import React, { Component } from "react";

const styles = {
    bgFull : {
        width: "100%",
        height: "100%",
        position: "absolute",
        background: "radial-gradient(circle, #4b78bc, #6194dd, #6daaff)",
    },
    code : {
        fontSize: "3em",
        color: "rgba(240, 240, 240, 1)",
        textAlign: "center",
        display: "block",
        position: "relative",
        top: "45%",
        textShadow: "0 0 25px rgba(255, 255, 255, 1)",
        webkitBoxReflect: "below 5px -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(0.5, transparent), to(white))",
        animation : "0.75s bounceIn"
    }
}

class PageNotFound extends Component {

    constructor(props){
        super(props);
    }

    render() {

        return (
            <div style={styles.bgFull} >
              <code style={styles.code}>
                  {this.props.message || "{--:++ 404 NOT FOUND ++:--}"}
              </code>
          </div>
        );
    }
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/Components/component_PageNotFound.js